import { ChartClient } from '@frontend/chart/api';
import { EquipmentCertificationsDonutChart } from '@frontend/chart/components';
import { Chart } from '@frontend/chart/types';
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { LendingEquipmentCertificationsDonutChartProps } from './lending-equipment-certifications-donut-chart.component';

export const useLendingEquipmentCertificationsDonutChart = (props: LendingEquipmentCertificationsDonutChartProps) => {
    const navigate = useNavigate();
    const [data, setData] = useState<Chart | undefined>(undefined);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (!props.accountId) {
            setIsLoading(false);
            return;
        }

        let cancelled = false;
        setIsLoading(true);

        ChartClient.fetchChartData(props.accountId, EquipmentCertificationsDonutChart.definition)
            .then((chart) => {
                if (!cancelled) {
                    setData(chart);
                }
            })
            .catch(() => {
                if (!cancelled) {
                    setData(undefined);
                }
            })
            .finally(() => {
                if (!cancelled) {
                    setIsLoading(false);
                }
            });

        return () => {
            cancelled = true;
        };
    }, [props.accountId]);

    return {
        data,
        isLoading,
        navigateToCertifiedEquipments: () => navigate('../certified_equipments')
    };
};
